import styled from "styled-components";

export const primaryGradient =
  "radial-gradient(circle at top -250px right -250px, rgba(190,75,219,1) 0%, rgba(76,110,245,1) 60%)";

export const secondaryGradient =
  "radial-gradient(circle at top -250px right -250px, rgba(56,194,216,1) 0%, rgba(56,109,188,1) 60%)";

export const textGradient = "linear-gradient(45deg, #4C6EF5 0%, #BE4BDB 124%)";

export const GradientBox = styled.div`
  background: ${primaryGradient};
`;
